export default {
 /* getArrivalTrains: state=>stationId=>{
    var ind= state.items.findIndex(x=>x.stationId==stationId);
    if(ind!=-1){
      var items=  state.trains[ind].data;
      var res= items;
      return res;
    }
    else return null;
  },
*/

}
